import { useState } from 'react';
import { Media } from '@weave/schema-gen-ts/dist/schemas/messaging/media/public/v1/service.pb';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { ImageGallery, PublicImageWarning } from '@frontend/image-gallery';
import { ImageGalleryPrefixes } from '@frontend/tracking-prefixes';
import { theme } from '@frontend/theme';
import { Heading, Modal, ModalControlModalProps } from '@frontend/design-system';
import { useContentComposer } from '../../content-composer-provider';

interface Props {
  modalProps: ModalControlModalProps;
  onSelect: (file?: Media) => void;
}

export const SelectImageModal = ({ modalProps, onSelect }: Props) => {
  const { t } = useTranslation('content-composer');
  const { locationIds } = useContentComposer();
  const [selectedImage, setSelectedImage] = useState<Media>();

  const handleSelect = (media?: Media) => {
    onSelect(media);
    setSelectedImage(undefined);
    modalProps.onClose();
  };

  return (
    <Modal {...modalProps} minWidth={700}>
      <Modal.Header>
        <div
          css={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: theme.spacing(3),
          }}
        >
          <Heading level={2}>{t('Upload or Select Image')}</Heading>
          <Icon name='x-small' color='light' size={16} onClick={modalProps.onClose} />
        </div>
      </Modal.Header>
      <Modal.Body>
        <PublicImageWarning />
        <ImageGallery
          locationIds={locationIds}
          handleImageSelect={setSelectedImage}
          onDoubleClick={handleSelect}
          selectedImages={[selectedImage]}
          css={{ '.image-gallery-content': { marginTop: theme.spacing(2) } }}
          trackingId={ImageGalleryPrefixes.ContentComposer}
        />
      </Modal.Body>
      <Modal.Footer
        primary={{
          label: t('Select'),
          onClick: () => handleSelect(selectedImage),
          disabled: !selectedImage,
        }}
        secondary={{ label: t('Cancel'), onClick: modalProps.onClose }}
      />
    </Modal>
  );
};
